<template>
  <div>
    <ISPPackage></ISPPackage>
  </div>
</template>

<script>
import ISPPackage from "./ISPPackage.vue";
export default {
  components: { ISPPackage },
  data() {
    return {};
  },
};
</script>

<style></style>
